import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.trim";
import { login as _login, logout as _logout, getInfo as _getInfo, UnifyLogout } from '@/api/common/user';
import { resetRouter } from '@/router';
import Vue from 'vue';
var getDefaultState = function getDefaultState() {
  return {
    userInfo: null,
    token: '',
    roles: [],
    userId: '',
    userName: '',
    avatarUrl: '',
    // 用户头像链接
    code: '' // 统一认证标识
  };
};
var state = getDefaultState();
var mutations = {
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INFO: function SET_INFO(state, userInfo) {
    state.userInfo = userInfo;
    // 后端返回的用户信息中若包含 avatarUrl，一并同步到 state.avatarUrl
    state.avatarUrl = userInfo && userInfo.avatarUrl || state.avatarUrl;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USERID: function SET_USERID(state, userId) {
    state.userId = userId;
  },
  SET_USERNAME: function SET_USERNAME(state, userName) {
    state.userName = userName;
  },
  SET_AVATAR: function SET_AVATAR(state, avatarUrl) {
    state.avatarUrl = avatarUrl;
    // 同步写回 userInfo，保证刷新/读取一致
    if (state.userInfo) {
      state.userInfo.avatarUrl = avatarUrl;
    }
  },
  SET_LOGINGCODE: function SET_LOGINGCODE(state, code) {
    state.code = code;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password,
      code = userInfo.code,
      codeKey = userInfo.codeKey,
      tenantId = userInfo.tenantId;
    return new Promise(function (resolve, reject) {
      _login({
        username: username.trim(),
        password: password,
        type: 2,
        code: code,
        codeKey: codeKey,
        tenantId: tenantId
      }).then(function (response) {
        if (Number(response.code) === 200) {
          var _ref2 = response && response.data || {},
            data = _ref2.data,
            datas = _ref2.datas;
          Vue.ls.set('ACCESS_TOKEN', data, 12 * 60 * 60 * 1000);
          commit('SET_TOKEN', data);
          commit('SET_INFO', datas);
          resolve();
        } else {
          reject(response);
        }
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfo().then(function (response) {
        if (Number(response.code) === 200) {
          // commit('SET_ROLES', result.roleIds)
          // commit('SET_BUTTONS', result.buttons)
          // commit('SET_USERID', result.userId)
          commit('SET_INFO', response.data);
          commit('SET_ROLES', [1, 2]);
          commit('SET_USERID', response.data.userId);
          commit('SET_USERNAME', response.data.realName);
        }
        resolve(response);
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve) {
      var logoutUrl = "".concat(Vue.ls.get('logoutUrl'), "&token=").concat(Vue.ls.get('ACCESS_TOKEN'));
      var accessCode = Vue.ls.get('ACCESS_CODE');
      if (accessCode && logoutUrl) {
        // 退出统一认证登录
        // UnifyLogout(state.token, logoutUrl).finally(() => {
        Vue.ls.remove('ACCESS_TOKEN');
        Vue.ls.remove('SET_CUT_ROUTE');
        Vue.ls.remove('ACCESS_CODE');
        Vue.ls.remove('logoutUrl');
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resetRouter();
        commit('RESET_STATE');
        window.location.href = logoutUrl;
        resolve();
        // })
      } else {
        _logout(state.token)["finally"](function () {
          Vue.ls.remove('ACCESS_TOKEN');
          Vue.ls.remove('SET_CUT_ROUTE');
          dispatch('tagsView/delAllViews', null, {
            root: true
          });
          resetRouter();
          commit('RESET_STATE');
          resolve();
        });
      }
      /* logout(state.token).finally(() => {
        Vue.ls.remove('ACCESS_TOKEN')
        Vue.ls.remove('SET_CUT_ROUTE')
        Vue.ls.set('ACCESS_CODE')
        resetRouter()
        commit('RESET_STATE')
         resolve()
      }) */
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      Vue.ls.remove('ACCESS_TOKEN');
      commit('RESET_STATE');
      resolve();
    });
  },
  setToken: function setToken(_ref6, response) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      Vue.ls.set('ACCESS_TOKEN', response.token, 12 * 60 * 60 * 1000);
      commit('SET_TOKEN', response.token);
      if (response.datas) commit('SET_INFO', response.datas);
      resolve();
    });
  },
  setUnifiedLoginCode: function setUnifiedLoginCode(_ref7, code) {
    var commit = _ref7.commit;
    console.log(123, code);
    return new Promise(function (resolve, reject) {
      commit('SET_LOGINGCODE', code);
      Vue.ls.set('ACCESS_CODE', code);
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};